import { Theme } from "@mui/material/styles"; 

const BookingTypeStyle = (theme: Theme) => ({ 
  backLink: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem', // Reduce font size for small screens
    },
  },
  backIcon: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem', // Adjust icon size
    },
  },
  imageContainer: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    height: '400px',
    [theme.breakpoints.down('sm')]: {
      height: '150px', // Reduce image height for mobile devices
      width: '150px', // Reduce image height for mobile devices
    },
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  businessImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as const,
  },
  imageNavButtonLeft: {
    position: 'absolute',
    left: theme.spacing(1),
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(0.5), // Adjust button position for smaller screens
    },
  },
  imageNavButtonRight: {
    position: 'absolute',
    right: theme.spacing(1),
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(0.5), // Adjust button position for smaller screens
    },
  },
  businessDetails: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1), // Reduce padding on smaller screens
    },
  },
  mapContainer: {
    height: '300px', // Adjust this value as needed
    width: '100%',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      height: '200px', // Reduce height on smaller screens
    },
  },
  tabsContainer: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2), // Reduce top margin on smaller screens
    },
  },
  tabContent: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0), // Reduce top margin for tab content
    },
  },
  mapMarker: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.primary.contrastText,
    fontSize: "12px",
    [theme.breakpoints.down('sm')]: {
      width: "15px", // Adjust size of map marker
      height: "15px",
      fontSize: "10px",
    },
  },
  aboutUs: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2), // Adjust spacing for smaller screens
      padding: theme.spacing(1),
    },
  },
  workingHours: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2), // Adjust spacing for smaller screens
      padding: theme.spacing(1),
    },
  },
});

export default BookingTypeStyle;
